<template>
    <div>
        <div v-if="$store.systemUse && !accepted" id="login_main">
            <div id="login_container" class="system-use">
                <div class="space-less"></div>
                <SystemUse @click="performRedirect" />
                <div class="space-more"></div>
            </div>
        </div>
        <template v-else>
            <div id="portal-header" class="unselectable">
                <div id="login-logo"></div>
            </div>
            <div class="login-sso-message">
                {{ $t('Please wait ...') }}
                <form v-if="url" id="sso_form" method="post" :action="url" target="_self">
                    <input type="hidden" name="org" :value="org" />
                    <input type="hidden" name="redirect" :value="redirect" />
                    <input type="hidden" name="product" :value="product" />
                    <input type="hidden" name="timestamp" :value="timestamp" />
                    <input type="hidden" name="hash" :value="hash" />
                </form>
            </div>
        </template>
    </div>
</template>

<script>
    import { post } from '@/utils/Http';
    import SystemUse from './SystemUse';
    import './resources/styles/login.scss';

    export default {
        name: 'SsoRedirect',
        components: { SystemUse },
        props: {
            orgName: {
                type: String,
                required: true,
            },
            auth: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                accepted: false,
                url: '',
                org: '',
                redirect: '',
                product: '',
                timestamp: 0,
                hash: '',
            };
        },
        created() {
            this.$store.user = {};
            if (!this.$store.systemUse) {
                this.$nextTick(() => {
                    this.performRedirect();
                });
            }
        },
        methods: {
            performRedirect() {
                this.accepted = true;
                const parts = window.location.href.split('/');
                // eslint-disable-next-line no-undef
                const redirect = (parts.slice(0, 3).join('/') + process.env.APP_API_PATH).slice(0, -1);
                post('login/ssoredirect', { orgName: this.orgName, auth: this.auth, redirect }).then((response) => {
                    if (response.status === 'OK') {
                        this.url = response.url.replace('{server.name}', window.location.host);
                        this.org = response.org;
                        this.redirect = response.redirect;
                        this.product = response.product;
                        this.timestamp = response.timestamp;
                        this.hash = response.hash;
                        this.$nextTick(() => {
                            document.getElementById('sso_form').submit();
                        });
                    } else {
                        this.$router.push('/message/1');
                    }
                });
            },
        },
    };
</script>
